import {ReactNode} from "react";
import {useLocation} from "react-router-dom";

interface PageTransitionProps {
    children: ReactNode;
}

// Keying by top-level section (not the full path) re-triggers the enter
// animation when moving between pages, but not for param changes within
// the same page (e.g. /forms -> /forms/:formId), which must keep their state.
export const PageTransition = ({children}: PageTransitionProps) => {
    const location = useLocation();
    const section = location.pathname.split("/")[1] || "root";

    return (
        <div key={section} className="w-full h-full animate-fade-in-up animate-duration-300">
            {children}
        </div>
    );
};
